var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-pic-root",style:(_vm.homePicStyle)},[_c('img',{staticClass:"home-pic-image",attrs:{"src":_vm.image}})])
}
var staticRenderFns = []

export { render, staticRenderFns }